import React from "react";
import Title from "../layouts/Title";
import ProjectsCard from "./ProjectsCard";
import one from "../../assets/images/projects/1.png";
import two from "../../assets/images/projects/2.png";
import three from "../../assets/images/projects/3.png";
import four from "../../assets/images/projects/4.png";
import five from "../../assets/images/projects/5.png";
import six from "../../assets/images/projects/6.png";
import MERN_Store from "../../assets/images/projects/MERN_Store.png";
import ecommerce from "../../assets/images/E.png";

const Projects = () => {
  return (
    <section id="projects" className="w-full py-20 border-b border-white/10">
      <div className="flex justify-center items-center text-center">
        <Title
          title="PRODUCTION & PERSONAL WORK"
          des="My Projects"
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 xl:gap-14 items-stretch">
        <ProjectsCard
          title="Kunvarji Trade"
          stack="NestJS · TypeScript · PostgreSQL · Prisma · WebSockets · AWS S3"
          des="Backend for a multi-tenant fintech KYC / trading onboarding platform. Built tenant hierarchy with NestJS middleware and Prisma, real-time WebSocket compliance under 200ms, S3 presigned document lifecycle (~40% less server overhead), and middleware orchestration across Rupeeseed, Techexcel, and Fundcore."
        />
        <ProjectsCard
          title="Rafter Sports"
          stack="NestJS · TypeScript · MongoDB · Prisma · WebSockets · PayPal · Trustly"
          des="Live sports betting platform work: Sportradar feeds for Soccer, Tennis, Basketball, and Hockey via WebSockets and cron jobs; real-time odds updates; PayPal and Trustly payment flows with admin transaction management; database design for live game and betting data at scale."
        />
        <ProjectsCard
          title="Legacy Assurance Plan"
          stack="NestJS · TypeScript · PostgreSQL · Prisma · AWS · React.js"
          des="Legal-tech document platform for attorneys. JWT + RBAC (~30% fewer auth tickets), document editor with placeholder detection (~30% faster render), indexed clause APIs (~25% faster), session-aware onboarding (~40% less drop-off), and independent attorney practice flows (~50% faster case setup)."
        />
        <ProjectsCard
          title="MERN Store"
          stack="MongoDB · Express · React · Node.js"
          des="Full-stack e-commerce store with category browsing, auth, and checkout flows. Demo: demo@gmail.com / helloWorld@123"
          src={MERN_Store}
          github="https://github.com/chandramouli35/mern_stack_store"
          live="https://mern-ecommerce-frontend-gamma.vercel.app/"
        />
        <ProjectsCard
          title="E-Commerce Shop"
          stack="React · Frontend"
          des="E-commerce storefront showcasing product categories and shopping UI."
          src={ecommerce}
          github="https://github.com/chandramouli35/pure-shop-glamour"
          live="https://e-commerce-shop-chandra.netlify.app/"
        />
        <ProjectsCard
          title="Book Hub"
          stack="React · REST APIs"
          des="Goodreads-style book discovery app with favorites, theming, and authenticated browsing."
          src={one}
          github="https://github.com/chandramouli35/Book-Hub"
          live="https://bookhubcm.ccbp.tech/"
        />
        <ProjectsCard
          title="Dashboard"
          stack="React · UI"
          des="Responsive dashboard UI for listing and managing items with a clean data layout."
          src={five}
          github="https://github.com/chandramouli35/adaptnxt_dashboard_assignment_"
          live="https://adaptnxtdashboardassgnmt.netlify.app/"
        />
        <ProjectsCard
          title="Roxiler E-Commerce"
          stack="React · Charts"
          des="E-commerce analytics UI showcasing categories, sales dates, and transaction views."
          src={six}
          github="https://github.com/chandramouli35/RoxilerEcomFrontend-main"
          live="https://roxilertcm.netlify.app/"
        />
        <ProjectsCard
          title="Travel Routes"
          stack="React · Frontend"
          des="Travel routes showcase with interactive frontend presentation."
          src={four}
          github="https://github.com/chandramouli35/media-Nv-frntEnd"
          live="https://media-nv-tcm.netlify.app/"
        />
        <ProjectsCard
          title="Framer Motions"
          stack="React · Framer Motion"
          des="UI motion showcase built with Framer Motion patterns."
          src={two}
          github="https://github.com/chandramouli35/Spur-fit-assignmentcm"
          live="https://spurfitassignment.netlify.app/"
        />
        <ProjectsCard
          title="Random Jokes Generator"
          stack="React · API"
          des="Lightweight client that fetches and displays jokes from a public API."
          src={three}
          github="https://github.com/chandramouli35/MobileFirst-Applications-Assignment"
          live="https://jokesmobilefirst.netlify.app/"
        />
      </div>
    </section>
  );
};

export default Projects;
